document.addEventListener('DOMContentLoaded', function () {
  window.dataLayer = window.dataLayer || [];

  // Experiment page view tracking
  if (window.location.pathname === '/pages/finishing-touches') {
    window.dataLayer.push({
      event: 'experiment_view',
      experiment_id: 'checkout_flow_test'
    });
  }

  // Button click tracking
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-track-click]');
    if (!btn) return;

    window.dataLayer.push({
      event: 'custom_button_click',
      button_name: btn.getAttribute('data-track-click'),
      button_location: btn.getAttribute('data-track-location') || ''
    });
  });
});